<template>
    <div class="h-full">
        <AppMobileTopbar
            :appName="appName"
            :authCustomer="authCustomer"
            :currentRoute="currentRoute"
        />
        <FlashMessage />

        <header
            v-if="pageMeta"
            class="bg-white shadow"
        >
            <div class="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
                <h1
                    class="text-xl md:text-2xl font-bold tracking-tight text-gray-900"
                >
                    {{ pageMeta.pageTitle }}
                </h1>
            </div>
        </header>

        <main class="h-full">
            <div class="max-w-5xl mx-auto px-4 py-4 sm:px-6 lg:px-8 space-y-4">
                <div
                    v-if="slots.left || slots.right"
                    class="flex items-center justify-between"
                >
                    <div>
                        <slot name="left" />
                    </div>
                    <div>
                        <slot name="right" />
                    </div>
                </div>
                <div
                    v-else
                    class="mt-4"
                ></div>

                <slot />
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import AppMobileTopbar from '@/Shared/Layout/Customer/Topbar/AppMobileTopbar.vue'
    import FlashMessage from '@/Shared/Component/FlashMessage.vue'
    import Customer from '@/App/Customer/Entity/Customer'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'

    interface AppLayoutProps {
        pageMeta: PageMeta | null
        appName: string
        authCustomer: Customer
        currentRoute: string
    }

    const props = defineProps<AppLayoutProps>()
    const slots: any = useSlots()
</script>
